import React, { Component } from 'react'
import { addLocaleData, IntlProvider } from 'react-intl'
import PropTypes from 'prop-types'
import { API } from 'aws-amplify'
import intlDA from 'react-intl/locale-data/da'
import Spinner from './components/Spinner'

addLocaleData(intlDA);

class Language extends Component {

  constructor(props) {
    super(props)

    this.state = {
      isLoading: true,
      i18nConfig: {
        locale: props.locale
      }
    }
  }

  async componentDidMount() {
    const { props } = this
    const url = `${props.locale === 'da' ? '' : `/${props.locale}`}/ski365.json`
    
    const messages = await API.get('cphill-www', url)
    this.setState(prevState => ({
      isLoading: false,
      i18nConfig: {
        ...prevState.i18nConfig,
        messages
      }
    }))
  }

  render () {
    const {state, props} = this

    if (state.isLoading) {
      return <Spinner />
    }

    return (
      <IntlProvider
        key={state.i18nConfig.locale}
        locale={state.i18nConfig.locale}
        messages={state.i18nConfig.messages}
        textComponent={React.Fragment}
      >
        {props.children}
      </IntlProvider>
    )
  }
}

Language.propTypes = {
  locale: PropTypes.string
}

Language.defaultProps = {
  locale: 'en'
}

export default Language